import {
    ActivatedRouteSnapshot,
    CanDeactivate,
    RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";

import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class CanDeactivateBlockNavigationIfChange<
    T extends BlockNavigationIfChange
> implements CanDeactivate<T>
{
    canDeactivate(
        component: T,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        const result = component.hasChanges
            ? component.hasChanges()
                ? confirm("You have changes which will be lost")
                : true
            : true;

        return result;
    }
}

export interface BlockNavigationIfChange {
    hasChanges: () => Observable<boolean> | Promise<boolean> | boolean;
}
